<template>
  <div class="self-what">
    <div class="g-box">
      <div class="title  kf-animate kf-animate-top">
        <div class="en">{{ dataInfo.tips }}</div>
        <div class="zh">{{ dataInfo.name }}</div>
      </div>
      <div class="content">
        <div class="items">
          <div
            class="item"
            v-for="item in dataList"
            :key="item.id"
            :style="{
              backgroundImage: 'url(' + item.image + ')'
            }"
          >
            <div class="tit">{{ item.title }}</div>
            <div class="subtit">{{ item.subtitle }}</div>
            <div class="intro">{{ item.tips }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 999,
      menuId: this.menuId
    });
    this.dataInfo = dataInfo;
    this.dataList = data;
  },
  methods: {}
};
</script>
<style lang="less">
.self-what {
  padding: 100px 0;
  box-sizing: border-box;
  .title {
    display: flex;
    align-items: center;
    text-align: center;

    .en {
      font-size: 72px;
      font-family: "en-tit";
      color: #000;
      line-height: 87px;
      text-transform: uppercase;
    }
    .zh {
      padding-left: 40px;
      font-size: 48px;

      font-family: Dream-LiHeiGB, Dream;
    }
  }
  .content {
    padding-top: 90px;
    .items {
      display: flex;
      .item {
        padding-left: 20px;
        padding-bottom: 30px;
        width: 175px;
        height: 400px;
        box-sizing: border-box;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .tit {
          height: 72px;
          font-size: 60px;
          font-family: "en-tit";
          color: #fff;
          line-height: 72px;
        }
        .subtit {
          height: 34px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #fff;
          line-height: 34px;
        }
        .intro {
          padding-top: 10px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #fff;
          line-height: 22px;
        }
      }
      .item:first-child {
        width: 500px;
        padding-left: 40px;
        .img {
          width: 500px;
          border-radius: 24px 0px 0px 24px;
        }
      }
      .item:last-child {
        .img {
          border-radius: 0px 24px 24px 0px;
        }
      }
    }
  }
}
</style>
